import React from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { DBSProduct } from 'types';
import { BankDetailsType } from 'types/bank';
import { buildCanonicalURL } from 'utils/bankPageUtils';
import BankDetails from '../../Banks/BankDetails/v2';
import ProductPage from '../../Banks/ProductPage/v2';

interface BankPageSelectorProps {
  bank: BankDetailsType;
  offers: DBSProduct[];
  bankOfferId?: string | null;
  highestInterestRate: string;
}

const BankPageSelector: React.FC<BankPageSelectorProps> = ({
  bank,
  offers,
  bankOfferId,
  highestInterestRate,
}) => {
  const router = useRouter();
  const { locale } = useIntl();

  const selectedOffer = bankOfferId && offers.find((offer) => offer.id === bankOfferId);
  const canonicalURL = buildCanonicalURL(router, locale, process.env.NEXT_PUBLIC_ENVIRONMENT_NAME);

  if (selectedOffer) {
    return (
      <ProductPage
        bank={bank}
        offers={offers}
        selectedOffer={selectedOffer}
        highestInterestRate={highestInterestRate}
        canonicalURL={canonicalURL}
        bankOfferId={bankOfferId}
      />
    );
  }

  return (
    <BankDetails
      bank={bank}
      offers={offers}
      bankOfferId={bankOfferId}
      highestInterestRate={highestInterestRate}
      canonicalURL={canonicalURL}
    />
  );
};

export default BankPageSelector;
